<template>
  <editor v-bind="$attrs" :api-key="key" :init="{plugins: 'wordcount'}" data-cy="editor" />
</template>
<script>
import Editor from '@tinymce/tinymce-vue'
export default {
  components: {
    editor: Editor
  },
  props: {
    value: null,
    key: { type: String, default: 'jst2bhgwfyj26xxbspjj1qjoeyi6ag3ofm2zi7os0un4965g' }
  },
  computed: {
    model: {
      get () {
        return this.value
      },
      set (value) {
        this.$emit('input', value)
      }
    }
  }
}
</script>
<style>
  .tox-notifications-container {
    display: none !important;
  }
</style>
